import { Navigate, Route, Routes } from 'react-router-dom'

import { PublicRoutes } from './PublicRoutes'
import { ErrorBoundary } from '../components/errorBoundary/ErrorBoundary'
import ErrorScreen from '../components/errorBoundary/ErrorScreen'
import Layout from '../components/Layout/Layout'
import { useUser } from '../context'
import { AdministrationPage, InitialForm } from '../pages'

export const PrivateRoutesAdmin = () => {
  // TODO: replace with
  // const { loadingUser, userRole, loadError } = useUser()
  // if (loadError) return <ErrorScreen />
  // if (loadingUser) return <Spinner />

  //   Opcional: mover la lógica a Layout o a un hook
  // Si ves que repites las mismas cuatro líneas en todas las rutas, puedes crear un wrapper tipo withPrivateGuard
  // o manejarlo dentro de Layout (por ejemplo, pasarle loading y error como props).
  const { userRole, loadingUser, initDone } = useUser()

  if (loadingUser || !initDone) {
    return <div>Loading...</div>
  }

  return (
    // <BrowserRouter>
    <ErrorBoundary fallback={<ErrorScreen />}>
      <Layout>
        <Routes>
          {userRole && initDone ? (
            <>
              <Route index element={<AdministrationPage part="dashboard" />} />
              <Route
                path="/"
                element={<AdministrationPage part="dashboard" />}
              />
              <Route
                path="/alumnos"
                element={<AdministrationPage part="admin-students" />}
              />
              <Route
                path="/alumnos/:part"
                element={<AdministrationPage part="admin-students" />}
              />
              <Route
                path="/profesores"
                element={<AdministrationPage part="admin-professors" />}
              />
              <Route
                path="/profesores/:part"
                element={<AdministrationPage part="admin-professors" />}
              />
              <Route
                path="/nuevo-usuario"
                element={<AdministrationPage part="admin-new-user" />}
              />
              <Route
                path="/perfil"
                element={<AdministrationPage part="admin-profile" />}
              />

              <Route
                path="/desafios"
                element={<AdministrationPage part="admin-challenge" />}
              />

              <Route
                path="/desafios/:part"
                element={<AdministrationPage part="admin-challenge" />}
              />

              <Route path="/initial-form" element={<InitialForm />} />

              {/* Ruta por defecto para rutas desconocidas */}

              <Route path="*" element={<Navigate to="/" replace />} />
            </>
          ) : (
            <Route path="/*" element={<PublicRoutes />} />
          )}
        </Routes>
      </Layout>
    </ErrorBoundary>
    // </BrowserRouter>
  )
}
